import as from 'ansis'
import { Command } from 'commander'

import { config } from '@/config'
import { getFileOrUrl } from '@/domains/document/helpers'
import { output } from '@/helpers/std-out'

export function ShareCommand() {
  const cmd = new Command('share')

  cmd.description('Share an OpenAPI file')
  cmd.argument('[file]', 'file to share')
  cmd.option(
    '-t, --token <token>',
    'pass a token to update an existing sandbox',
  )
  cmd.action(async (fileArgument: string, { token }: { token?: string }) => {
    if (!fileArgument) {
      return output
        .error()
        .title('Invalid argument')
        .message('Please provide a file path')
        .exit('error')
    }

    const url = new URL(config.projects.sandbox)
    url.pathname = '/api/share'
    if (token) {
      url.searchParams.append('token', token)
    }

    fetch(url.toString(), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        content: await getFileOrUrl(fileArgument),
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        const { id, token: newToken } = data
        output
          .info()
          .line(as.green.bold('Your OpenAPI file is public.'))
          .line()
          .table(
            [
              [
                `${as.green('➜')} ${as.white.bold('API Reference:')}`,
                as.cyan(`https://sandbox.scalar.com/p/${id}`),
              ],
              [
                `${as.grey('➜')} ${as.grey.bold('Editor:')}`,
                as.cyan(`https://sandbox.scalar.com/e/${id}`),
              ],
              [],
              [
                `${as.grey('➜')} ${as.grey.bold('OpenAPI JSON:')}`,
                as.cyan(`https://sandbox.scalar.com/files/${id}/openapi.json`),
              ],
              [
                `${as.grey('➜')} ${as.grey.bold('OpenAPI YAML:')}`,
                as.cyan(`https://sandbox.scalar.com/files/${id}/openapi.yaml`),
              ],
            ],
            { padding: 1 },
          )
          .line()
          .line('Use the token to update the existing sandbox:')
          .line()
          .line(
            `${as.grey('$')} ${as.white.bold('scalar document share --token=')}${as.cyan.bold(`${newToken}`)} `,
          )
          .line()
          .print()
      })
      .catch((error) => {
        output
          .error()
          .title('Failed to share the file.')
          .message(`Details: ${error}`)
          .exit('error')
      })
  })

  return cmd
}
